import {
    Button,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalNext,
} from '@jutro/components';
import { useValidation } from '@xengage/gw-portals-validation-react';
import {
    useDataRefresh,
    ViewModelForm,
} from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './ClaimDetails.module.scss';
import metadata from './CreateNotePopUp.metadata.json5';

function CreateNotePopUp(props) {
    const {
        title,
        actionBtnLabel,
        cancelBtnLabel,
        isOpen,
        onResolve,
        onReject,
        viewModelService,
        disclaimerNote
    } = props;
    const { refreshData } = useDataRefresh();
    const [noteVM, updateNoteVM] = useState();
    const { isComponentValid, onValidate } = useValidation('CreateNotePopUp');
    const [pageSubmitted, setPageSubmitted] = useState(false)

    useEffect(() => {
        const initialNoteVM = viewModelService.create(
            {
                subject: '',
                body: '',
            },
            'cc',
            'edge.capabilities.note.dto.NoteDTO'
        );

        updateNoteVM(initialNoteVM);
        // This will call only once.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const writeValue = useCallback(
        (value, path) => {
            _.set(noteVM, path, value);
            updateNoteVM(noteVM);
            refreshData();
        },
        [refreshData, noteVM]
    );

    const handleSave = useCallback(() => {
        setPageSubmitted(true);

        if(isComponentValid){
            onResolve(noteVM);
        }
    }, [isComponentValid, onResolve, noteVM]);

    const overrides = {
        '@field':{
            showErrors: pageSubmitted
        }
    }

    return (
        <ModalNext isOpen={isOpen}>
            <ModalHeader title={title} />
            <ModalBody
                contentLayout={{
                    component: 'grid',
                }}
            >
                <ViewModelForm
                    overrideProps={overrides}
                    uiProps={metadata.pageContent}
                    model={noteVM}
                    onValidationChange={onValidate}
                    onValueChange={writeValue}
                />
            </ModalBody>
            <ModalFooter>
                <Button onClick={onReject} type="outlined" label={cancelBtnLabel} />
                <Button onClick={handleSave} label={actionBtnLabel} />
            </ModalFooter>
            {disclaimerNote && <p className={styles.sendMessageNote}>{disclaimerNote}</p>}
        </ModalNext>
    );
}

CreateNotePopUp.propTypes = {
    initialNoteObj: PropTypes.shape({}).isRequired,
    title: PropTypes.string.isRequired,
    actionBtnLabel: PropTypes.shape({}).isRequired,
    cancelBtnLabel: PropTypes.shape({}).isRequired,
    onReject: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onResolve: PropTypes.func.isRequired,
};

export default CreateNotePopUp;
